import React from "react";
import { useTranslation } from "react-i18next";
import { FiCheck } from "react-icons/fi";
import { useLanguage } from "../../contexts/language";
import "./plan-subscription-section.scss";

const AppleStoreImage = require("../../assets/images/Apple-Store.png");
const GooglePlayImage = require("../../assets/images/Google-Play.png");

const APP_WIZEWINGS_APPLE =
  "https://apps.apple.com/us/app/wizewings/id1637461718";
const APP_WIZEWINGS_GOOGLE =
  "https://play.google.com/store/apps/details?id=aero.wizewings.wizewings";

const PLAN_PRICES = {
  pt: {
    currency: "R$",
    price: "59,99",
    period: "/mês",
  },
  en: {
    currency: "$",
    price: "49.99",
    period: "/month",
  },
};

export function PlanSubscriptionSection() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const planPrice = currentLanguage?.startsWith("pt")
    ? PLAN_PRICES.pt
    : PLAN_PRICES.en;

  const services = [ t("")
    //t("planSubscriptionService1"),
    //t("planSubscriptionService2"),
    //t("planSubscriptionService3"),
    //t("planSubscriptionService4"),
  ];

  return (
    <section className="plan-subscription-section">
      <header className="plan-subscription-header">
        <h2>{t("planSubscriptionTitle")}</h2>
        <p>{t("planSubscriptionSubtitle")}</p>
      </header>

      <article className="plan-subscription-card">
        <span className="plan-subscription-badge">
          {t("planSubscriptionBadge")}
        </span>

        <h3>{t("planSubscriptionCardTitle")}</h3>

        <div className="plan-subscription-price">
          <span className="plan-subscription-currency">
            {planPrice.currency}
          </span>
          <strong>{planPrice.price}</strong>
          <span className="plan-subscription-period">{planPrice.period}</span>
        </div>

        <ul className="plan-subscription-services">
          {services.map((service) => (
            <li key={service}>
              <span className="plan-subscription-check">
                <FiCheck aria-hidden="true" />
              </span>
              <span>{service}</span>
            </li>
          ))}
        </ul>

        <div className="plan-subscription-store-links">
          <a
            href={APP_WIZEWINGS_APPLE}
            target="_blank"
            rel="noreferrer"
            aria-label={t("downloadOnAppleStore")}
          >
            <img src={AppleStoreImage} alt={t("downloadOnAppleStore")} />
          </a>
          <a
            href={APP_WIZEWINGS_GOOGLE}
            target="_blank"
            rel="noreferrer"
            aria-label={t("downloadOnGooglePlay")}
          >
            <img src={GooglePlayImage} alt={t("downloadOnGooglePlay")} />
          </a>
        </div>

        <p className="plan-subscription-note">{t("planSubscriptionNote")}</p>
      </article>
    </section>
  );
}
